__turbopack_context__.v({
  "bigDesktopPageWidth": "faq-module-scss-module__4hMkbq__bigDesktopPageWidth",
  "body": "faq-module-scss-module__4hMkbq__body",
  "chevron": "faq-module-scss-module__4hMkbq__chevron",
  "chevronRotated": "faq-module-scss-module__4hMkbq__chevronRotated",
  "desktopPageWidth": "faq-module-scss-module__4hMkbq__desktopPageWidth",
  "faqAnswer": "faq-module-scss-module__4hMkbq__faqAnswer",
  "faqContainer": "faq-module-scss-module__4hMkbq__faqContainer",
  "faqQuestion": "faq-module-scss-module__4hMkbq__faqQuestion",
  "faqSection": "faq-module-scss-module__4hMkbq__faqSection",
  "open": "faq-module-scss-module__4hMkbq__open",
  "root": "faq-module-scss-module__4hMkbq__root",
  "sanitized": "faq-module-scss-module__4hMkbq__sanitized",
  "threeLineEllipse": "faq-module-scss-module__4hMkbq__threeLineEllipse",
});
